import React from "react";
import styled from "styled-components";
import { focusState } from "../tokens/a11y";
import { hideVisually } from "polished";

const SkipNavigation = ({ skipNavId }) => (
  <Link href={`#${skipNavId}`}>Skip to main content</Link>
);

const Link = styled.a`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 1rem;
  padding: 1rem;
  text-align: center;
  text-decoration: none;
  background-color: white;
  z-index: 10;

  :not(:focus):not(:active) {
    ${hideVisually};
  }

  &:focus {
    ${focusState(({ theme }) => theme.palette.darkerLightBlue)};
    box-shadow: 0 0 0 0.35rem ${({ theme }) => theme.palette.darkerLightBlue};
  }
`;

export default SkipNavigation;
